import { CustomEvents } from '../types/CustomEvents';

class CustomEventUtil {
  public static send<T = any>(name: CustomEvents, value?: T) {
    if (typeof window.CustomEvent !== 'function') {
      function customEvent(event: string, params: any) {
        const config = params || { bubbles: false, cancelable: false, detail: null };
        const evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, config.bubbles, config.cancelable, config.detail);
        return evt;
      }

      (window as any).CustomEvent = customEvent;
    }

    window.dispatchEvent(
      new CustomEvent<T>(name, {
        detail: value,
      }),
    );
  }
}

export { CustomEventUtil };
